import { PureComponent } from 'react';
import Html from 'Component/Html';
import TextPlaceholder from 'Component/TextPlaceholder';
import ExpandableContent from 'Component/ExpandableContent';
import './PromotionConditions.style';

class PromotionConditions extends PureComponent {
    render() {
        const { isLoading, conditions, conditions_expanded } = this.props;

        if (isLoading) {
            return (
                <div block="Promotion" elem="Conditions">
                    <TextPlaceholder />
                </div>
            );
        }

        if (!conditions) {
            return null;
        }

        return (
            <div block="Promotion" elem="Conditions">
                <ExpandableContent
                  heading={ __('Promotion conditions') }
                  isContentExpanded={ conditions_expanded }
                  mix={ {
                      block: 'PromotionConditions'
                  } }
                >
                    { <Html content={ conditions } /> }
                </ExpandableContent>
            </div>
        );
    }
}

export default PromotionConditions;
